// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import VueLazyload from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import base from './utils/base'
import coms from './components'
import echarts from 'echarts'
import * as filters from './filters'
import vant from './utils/vant'
// import 'wowjs/css/libs/animate.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(VueLazyload, {
  loading: require('./assets/img/loading.gif'),//加载中图片，一定要有，不然会一直重复加载占位图
  error: require('./assets/img/noimg.png')  //加载失败图片
});
Vue.prototype.$echarts = echarts
Vue.use(Element)
Vue.use(vant)
Vue.use(base)
Vue.use(coms)
Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import fetch from '@/api/api.js'
Vue.prototype.fetch = fetch

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js